<template>
  <div
    class="export-container"
    v-loading.fullscreen.lock="pageLoading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
    element-loading-text="加载中..."
  >
    <search
      ref="search"
      :formModel="formModel"
      :formButton="formButton"
      :rules="rules"
      :mulTime="mulTime"
      :deviceModelBusiType="1"
      :upLeveName="'export'"
    ></search>

    <div>
      <template v-if="formModel.exportType === '1'">
        <warning-day v-if="dayAlarmsArr.length" :optionData="dayAlarmsArr"></warning-day>
        <div class="empty-box" v-else-if="!dayAlarmsArr.length && showEmpty">
          <el-empty :image-size="200" description=""></el-empty>
        </div>
      </template>

      <template v-if="formModel.exportType === '2'">
        <infrared-day v-if="dayInfraredArr.length" :optionData="dayInfraredArr"></infrared-day>
        <div class="empty-box" v-else-if="!dayInfraredArr.length && showEmpty">
          <el-empty :image-size="200" description=""></el-empty>
        </div>
      </template>

      <template v-else-if="formModel.exportType === '3'">
        <multipleCom :tableData="multipleArr"></multipleCom>
      </template>

      <template v-else-if="formModel.exportType === '4'">
        <hourlyAverage-com :tableData="avgHourData"></hourlyAverage-com>
      </template>

      <template v-else-if="formModel.exportType === '5'">
        <boxplot-com v-if="boxplotArr.length" :optionData="boxplotArr"></boxplot-com>
        <div class="empty-box" v-else-if="!boxplotArr.length && showEmpty">
          <el-empty :image-size="200" description=""></el-empty>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import search from '@/components/mTable/search';
import warningDay from './components/summer-of-day-warning';
import infraredDay from './components/infrared-of-day';
import multipleCom from './components/multiple';
import hourlyAverageCom from './components/hourly-average';
import boxplotCom from './components/boxplot';

import { arrify, dayTime, downFile } from '@/utils/utils';
import { validParam } from '../utils';
import { searchResultServer } from '@/api/dataAnalysis';

export default {
  components: {
    search,
    warningDay,
    infraredDay,
    multipleCom,
    hourlyAverageCom,
    boxplotCom
  },
  watch: {
    'formModel.exportType': {
      handler(newVal) {
        if (newVal) {
          this.showEmpty = false;
        }
      }
    }
  },
  data() {
    return {
      pageLoading: false,
      showEmpty: false,
      formModel: {
        sn: [],
        officeId: [],
        taskId: [],
        deviceModel: '',
        rangeDateVal: [dayTime().begin.getTime(), dayTime().end.getTime()],
        exportType: ''
      },
      mulTime: {
        dateType: 'datetimerange'
      },
      rules: {
        taskId: [{ required: true, message: '请选择任务', trigger: 'change' }],
        officeId: [{ required: true, message: '请选择机构', trigger: 'change' }],
        // deviceModel: [{ required: true, message: '请选择设备型号', trigger: 'change' }],
        exportType: [{ required: true, message: '请选择导出类型', trigger: 'change' }]
      },
      formButton: [
        {
          text: '查询',
          loading: false,
          event: this.search
        },
        {
          text: '导出',
          loading: false,
          event: this.exportData
        }
      ],
      dayAlarmsArr: [], // 日报警次数
      dayInfraredArr: [], // 日红外计数
      multipleArr: [], // 报警值高于本底
      avgHourData: null, // 小时平均值
      boxplotArr: [] // 箱线图数据
    };
  },
  methods: {
    loadData(val) {
      let { officeId, taskId, deviceModel, sn, rangeDateVal } = this.formModel;
      let params = validParam({
        officeId,
        taskId,
        deviceTypeCode: arrify(deviceModel || null),
        sn,
        beginTime: rangeDateVal[0],
        endTime: rangeDateVal[1]
      });
      let apiArray = [
        '/stat/dayAlarmTimes',
        '/stat/dayInfraredCount',
        '/stat/alarmBgroundMultiple',
        '/stat/avgHourData',
        '/stat/diffusionData'
      ];

      let exportTypeNumber = Number(val) - 1;
      if (this.formModel.exportType === '4' && !this.formModel.deviceModel) {
        this.$message.warning('请选择设备型号');
        return;
      }

      this.pageLoading = true;

      searchResultServer(apiArray[exportTypeNumber], params)
        .then(res => {
          if (res.code === 200) {
            if (val === '1') {
              this.dayAlarmsArr = res.data;
            } else if (val === '2') {
              this.dayInfraredArr = res.data;
            } else if (val === '3') {
              this.multipleArr = res.data;
            } else if (val === '4') {
              this.avgHourData = res.data;
            } else if (val === '5') {
              let arr = [];
              for (var i in res.data) {
                let obj = {
                  sn: i,
                  dataList: res.data[i].dataList,
                  dimensions: res.data[i].dimensions
                };
                arr.push(obj);
              }
              this.boxplotArr = arr;
            }
          }
        })
        .finally(() => {
          this.pageLoading = false;
          this.showEmpty = true;
        });
    },
    search() {
      this.loadData(this.formModel.exportType);
    },
    exportData() {
      let { officeId, taskId, deviceModel, sn, rangeDateVal } = this.formModel;
      let params = validParam({
        officeId,
        taskId,
        deviceTypeCode: arrify(deviceModel || null),
        sn,
        beginTime: rangeDateVal[0],
        endTime: rangeDateVal[1]
      });
      let apiArr = [
        '/stat/dayAlarmTimesExport',
        '/stat/dayInfraredCountExport',
        '/stat/alarmBgroundMultipleExport',
        '/stat/avgHourDataExport',
        '/stat/diffusionDataExport'
      ];

      let exportTypeNumber = Number(this.formModel.exportType) - 1;

      if (this.formModel.exportType === '4' && !this.formModel.deviceModel) {
        this.$message.warning('请选择设备型号');
        return;
      }
      this.formButton[1].loading = true;
      downFile({
        url: apiArr[exportTypeNumber],
        method: 'post',
        data: params
      }).finally(() => {
        this.formButton[1].loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.export-container {
  .empty-box {
    margin-top: 100px;
    display: flex;
    justify-content: center;
    .el-empty {
      text-align: center;
    }
  }
}
</style>
